import { dateFormats } from '../../../shared/packages/dateTime';
import { fieldNames } from '../constants';

const asIs = (value) => value;

const formValueNormalizers = {
  [fieldNames.name]: (value) => {
    return value?.trim() || undefined;
  },

  [fieldNames.description]: (value) => {
    return value?.trim() || undefined;
  },

  [fieldNames.availableToClient]: (value) => {
    return value;
  },

  [fieldNames.fromDate]: prepareDate,

  [fieldNames.toDate]: prepareDate,

  [fieldNames.files]: (value) => {
    if (!value?.length) return undefined;

    const result = [];
    value.forEach((file) => {
      if (file.status !== 'error') {
        result.push(file instanceof File ? file : file.originFileObj);
      }
    });

    return result;
  },

  [fieldNames.clientId]: asIs,
  [fieldNames.typeId]: asIs,
};

export const normalizeFormValues = (values) => {
  return Object.entries(values).reduce((acc, [key, value]) => {
    const val = formValueNormalizers[key]?.(value);

    if (val !== undefined) {
      acc[key] = val;
    }

    return acc;
  }, {});
};

function prepareDate(value) {
  return value ? value.format(dateFormats.ISO) : undefined;
}
